import React from "react";
import { PageHeader } from "./../Components";
import setNavigation from "actions/set_navigation";
import create_card_applications from "actions/create_card_applications";
import get_cards from "actions/get_cards";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Col } from "Components";
import {
  NotificationContainer,
  NotificationManager
} from "react-notifications";
import { baseUrl } from "env";
import ReactHtmlParser from "react-html-parser";
class Contact extends React.PureComponent {
  state = {
    card_id: null
  };
  async componentDidMount() {
    await this.props.get_cards();
  }
  submit = async () => {
    await this.props.create_card_applications({
      tc: this.state.tc,
      card_id: this.state.card_id,
      phone: this.state.phone
    });
  };

  validateEmail = email => {
    const regex = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(email).toLowerCase());
  };
  componentWillReceiveProps(props) {
    if (
      props.alert &&
      props.alert !== this.props.alert &&
      props.alert.message
    ) {
      if (props.alert.type === "success") {
        NotificationManager.success(props.alert.message, "Başarılı");
        this.setState({
          tc: "",
          phone: "",
          card_id: ""
        });
        // notification.success({
        //   message: props.alert.message,
        //   description: props.alert.description
        // });
      } else {
        NotificationManager.error(props.alert.message, "Başarısız");

        // notification.error({
        //   message: props.alert.message,
        //   description: props.alert.description
        // });
      }
    }
  }
  render = () => (
    <div>
      <NotificationContainer />
      <PageHeader headerClass={"contact-us"} pageName="Kart Başvur Formu" />
      {/* <JSONTree data={this.state}/> */}
      <div className="container mt80 mb80 contact_us_page">
        <p className="title">Kart Başvur Formu</p>

        <div className="row mt40">
          <Col l={6} m={12}>
            <input
              value={this.state.tc}
              onChange={e => {
                this.setState({
                  tc: e.target.value
                });
              }}
              placeholder="Kimlik No"
            />
          </Col>
          <Col l={6} m={12}>
            <input
              value={this.state.phone}
              onChange={e => {
                this.setState({
                  phone: e.target.value
                });
              }}
              placeholder="Telefon Numaranız"
            />
          </Col>
        </div>
        <div className="row">
          <Col l={12} m={12}>
            <div className="form_row" style={{ marginTop: 0 }}>
              <p>Kart Tipi :</p>
              {this.props.cards.map((i, index) => (
                <div
                  onClick={() => {
                    this.setState({
                      card_id: i.id
                    });
                  }}
                  className={`card_selection ${
                    this.state.card_id === i.id ? "active" : ""
                  }`}
                >
                  <div className="content">
                    <p>{i.title}</p>
                    {i.content_html
                      ? ReactHtmlParser(JSON.parse(i.content_html))
                      : null}
                  </div>
                  <img
                    className="cover"
                    alt=""
                    src={`${baseUrl}/api/media/media/${i.media_id}`}
                  />
                </div>
              ))}
            </div>
          </Col>
        </div>

        <div className="row">
          <button
            onClick={this.submit}
            disabled={
              !this.state.tc || !this.state.phone || !this.state.card_id
            }
            className="submit-btn"
          >
            GÖNDER
          </button>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = state => ({
  navigation: state.navigation,
  alert: state.card_applications ? state.card_applications.alert : [],
  cards: state.cards ? state.cards.data : [],
  screen: state.screen
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setNavigation,
      create_card_applications,
      get_cards
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contact);
